import S from "./EmailNotificationFooter.module.scss";
import emailFooter from "@/assets/images/email/footer.png";

export const EmailNotificationFooter = () => {
  return (
    <div className={S.root}>
      <div className={S.divider}></div>
      <div className={S.socialCollection}>
        <div className={S.socialItem}>
          <a href="https://www.securityjourney.com/">
            <img src={emailFooter} alt="Security Journey" />
          </a>
        </div>
      </div>
      <div className={S.address}>3402 Apex Peakway, Apex, NC 27502</div>
      <div className={S.divider}></div>
      <br />
    </div>
  );
};
